import { INSIGHTS } from "constants/action-types";

export const fetchCategoryInsights = (viewAsCompanyId: string = null) => ({
    type: INSIGHTS.FETCH_CATEGORY_INSIGHTS.START,
    payload: {
        viewAsCompanyId,
    },
});
